module.exports = __webpack_public_path__ + "img/etape4.08dc8fe6.png";